import React, { useEffect, useRef, useState } from 'react';

const defaultSortOptions = [
    { value: 'name', label: 'Name' },
    { value: 'updatedAt', label: 'Date Modified' },
    { value: 'createdAt', label: 'Date Created' },
    { value: 'createdBy', label: 'Created By' }
];

export default function SelectorSearchSortBar({
    searchQuery,
    onSearchChange,
    searchPlaceholder = 'Search...',
    sortBy,
    onSortByChange,
    sortOrder,
    onSortOrderToggle,
    sortOptions = defaultSortOptions,
    bleedToContainerBottom = true,
    searchTrailing = null,
    autoFocus = false,
    showSearch = true,
    showSortButton = true,
    sortOpen: sortOpenProp,
    onSortOpenChange
}) {
    const [sortOpenInternal, setSortOpenInternal] = useState(false);
    const sortOpen = sortOpenProp ?? sortOpenInternal;
    const searchInputRef = useRef(null);
    const showSearchRow = showSearch || showSortButton || searchTrailing;

    useEffect(() => {
        if (autoFocus && showSearch) {
            searchInputRef.current?.focus();
        }
    }, [autoFocus, showSearch]);

    const toggleSort = () => {
        const next = !sortOpen;
        if (sortOpenProp === undefined) setSortOpenInternal(next);
        onSortOpenChange?.(next);
    };

    return (
        <>
            {showSearchRow && (
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.35rem' }}>
                    {showSearch && (
                        <div style={{ position: 'relative', display: 'flex', alignItems: 'center', flex: 1, minWidth: 0 }}>
                            <i
                                className="fa-solid fa-magnifying-glass"
                                style={{
                                    position: 'absolute',
                                    left: '0.6rem',
                                    color: 'var(--text-secondary)',
                                    fontSize: '0.8rem'
                                }}
                            ></i>
                            <input
                                ref={searchInputRef}
                                type="text"
                                placeholder={searchPlaceholder}
                                className="input-field"
                                value={searchQuery}
                                onChange={e => onSearchChange(e.target.value)}
                                style={{
                                    margin: 0,
                                    padding: '0.35rem 0.5rem 0.35rem 1.8rem',
                                    fontSize: '0.8rem',
                                    width: '100%'
                                }}
                            />
                        </div>
                    )}
                    {searchTrailing}
                    {showSortButton && (
                        <button
                            type="button"
                            className="btn-secondary"
                            onClick={toggleSort}
                            title="Sort"
                            aria-label="Sort"
                            aria-expanded={sortOpen}
                            style={{
                                margin: 0,
                                padding: '0.35rem 0.5rem',
                                fontSize: '0.8rem',
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '0.3rem',
                                flexShrink: 0,
                                background: sortOpen ? 'var(--accent-glow)' : undefined,
                                borderColor: sortOpen ? 'var(--accent)' : undefined,
                                color: sortOpen ? 'var(--accent)' : undefined
                            }}
                        >
                            <i className="fa-solid fa-arrow-down-a-z"></i>
                        </button>
                    )}
                </div>
            )}

            {sortOpen && (
                <div style={{
                    margin: bleedToContainerBottom ? '0 -1.5rem -1.5rem -1.5rem' : '0 -1.5rem',
                    padding: '0.75rem 1.5rem',
                    width: 'calc(100% + 3rem)',
                    borderTop: '1px solid var(--border)',
                    borderBottom: '1px solid var(--border)',
                    background: 'var(--bg-secondary)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: '0.5rem'
                }}>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.35rem',
                        fontSize: '0.8rem',
                        color: 'var(--text-secondary)',
                        flex: 1
                    }}>
                        <span>Sort:</span>
                        <select
                            value={sortBy}
                            onChange={(e) => onSortByChange(e.target.value)}
                            style={{
                                background: 'transparent',
                                border: 'none',
                                color: 'var(--text-primary)',
                                fontWeight: 600,
                                cursor: 'pointer',
                                fontSize: '0.8rem',
                                outline: 'none',
                                padding: '2px 4px'
                            }}
                        >
                            {sortOptions.map(option => (
                                <option
                                    key={option.value}
                                    value={option.value}
                                    style={{ background: 'var(--bg-card)', color: 'var(--text-primary)' }}
                                >
                                    {option.label}
                                </option>
                            ))}
                        </select>
                    </div>
                    <button
                        onClick={onSortOrderToggle}
                        style={{
                            background: 'transparent',
                            border: 'none',
                            cursor: 'pointer',
                            color: 'var(--text-secondary)',
                            fontSize: '0.85rem',
                            display: 'inline-flex',
                            alignItems: 'center',
                            padding: '4px',
                            borderRadius: '4px',
                            transition: 'var(--transition)'
                        }}
                        title={sortOrder === 'asc' ? 'Sort Ascending' : 'Sort Descending'}
                    >
                        <i className={`fa-solid ${sortOrder === 'asc' ? 'fa-arrow-up' : 'fa-arrow-down'}`}></i>
                    </button>
                </div>
            )}
        </>
    );
}
